import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { I18nModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { NotifyMeModalComponent } from './notify-me-modal/notify-me-modal.component';
import { NotifyMeComponent } from './notify-me.component';

@NgModule({
  declarations: [NotifyMeComponent, NotifyMeModalComponent],
  imports: [CommonModule, I18nModule, MatIconModule, MatCheckboxModule, MatSlideToggleModule, MediaModule],
  exports: [NotifyMeComponent],
})
export class NotifyMeModule {}
